import React from 'react'

import Hero from '../Components/Hero/Hero'
import AboutSection from '../Components/AboutSection/AboutSection'
import OurTeam from '../Components/OurTeam/OurTeam';
import Newsletter from '../Components/Newsletter/Newsletter'

const AboutPage = () => {
  return (
    <div>
      
       <Hero/>
       <AboutSection />
       <OurTeam />
       <Newsletter />
      
    </div>
  )
}

export default AboutPage
